import IJobSection from "../../interfaces/IJobSection";
import { BoxHeader } from "./box-header";
import KnownMutantsTable from "../KnownMutantsTable";
import * as React from "react";
import { LogoUniprot } from "./logo-uniprot";
import { CheckedSpinner } from "./checked-spinner";
import { useResultsContext } from "../../context/results-context";
import { Section } from "./section";

export function SectionKnownMutants({section}: {section: IJobSection}) {
  const {results, uniprot} = useResultsContext();
  const loading = uniprot.naturalVariants === null || uniprot.experimentalMutants === null;
  return (
    <Section section={section} style={{
      marginTop: '1rem',
      position: 'relative',  // for UniProt logo
    }}>
      <LogoUniprot accession={results.uniprotAccession}/>
      <BoxHeader section={section}/>
      {loading ? (
        <div className="ll-section-body ll-section-spinner">
          <CheckedSpinner withText={true}/>
        </div>
      ) : (
        <div className="ll-section-body ll-space-top">
          {uniprot.naturalVariants.length > 0 && <>
            <h3>Natural instances</h3>
            <div style={{ padding: '0 3rem' }}>
              <KnownMutantsTable sequence={results.sequence} mutants={uniprot.naturalVariants} naturalVariants allPublications={uniprot.publications} />
            </div>
          </>}
          {uniprot.experimentalMutants.length > 0 && <>
            <h3>Experimental data</h3>
            <div style={{ padding: '0 3rem' }}>
              <KnownMutantsTable sequence={results.sequence} mutants={uniprot.experimentalMutants} allPublications={uniprot.publications} />
            </div>
          </>}
        </div>
      )}

    </Section>
  )
}